/* eslint-disable */ 
import axios from 'axios';
import Vue from 'vue';

export default {
  getLikes() {
    axios.get('https://graph.facebook.com/oauth/access_token?client_id=251082192056867&client_secret=' +
    'cd8c45280e7c205ee8a21a5cb769d861&grant_type=client_credentials').then((resp) => {
      console.log(resp);
    }).catch((resp) => {
      console.log(resp);
    });
  },

  init() {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: process.env.FACEBOOK_ID,
        autoLogAppEvents: true,
        cookie: true,
        xfbml: true,
        version: 'v2.10',
      });
      window.FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      let js = d.getElementsByTagName(s)[0];
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },

  getLikes2() {
    (function (d, s, id) {
      let js = d.getElementsByTagName(s)[0];
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    Vue.FB.api(
      '/1422344281153410/likes',
      (response) => {
        console.log(response);

        if (response && !response.error) {
          console.log(response);
          /* handle the result */
        }
      },
    );
  },

  login(succ) {
    window.FB.login((resp) => {
      if (resp.authResponse) {
        succ(resp.authResponse.accessToken);
      } else {
        console.log('User cancelled login or did not fully authorize.');
      }
    }, { scope: 'public_profile,email' });
  },
};



// WEBPACK FOOTER //
// ./src/api/facebook.js